import type { MaybeRefOrGetter } from 'vue'

import { computed, toValue } from 'vue'

import type { UseEntityQueryOptions } from '@/support/query/UseEntityQueryOptions.types'

import { useLocationsQuery } from '@/domains/locations/composables/use-locations-query/useLocationsQuery'

/** `options` reaches the locations query, so a caller mounted on every page can hold it until it is needed. */
export const useResolvedDefaultLocation = (
  configUlid: MaybeRefOrGetter<string | null>,
  options: UseEntityQueryOptions = {}
) => {
  const { data: locationsData, isLoading } = useLocationsQuery(options)

  const resolvedLocationId = computed<number | null>(() => {
    const locations = locationsData.value
    if (!locations?.length) return null

    // 1. Try matching by config ULID
    const ulid = toValue(configUlid)
    if (ulid) {
      const match = locations.find(l => l.ulid === ulid)
      if (match) return Number(match.id)
    }

    // 2. Fallback: auto-select if exactly one location
    if (locations.length === 1) return Number(locations[0].id)

    return null
  })

  return { resolvedLocationId, isLoading }
}
